import {Card, showNotification} from 'platform/components';

import {ReactElement} from 'react';

import {
  useSmsGetKonzultaCredentialsQuery,
  useSmsPatchKonzultaCredentialsMutation,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';
import {KonzultaCredentials} from '@dms/teas';

import {ServiceAuthenticationForm} from './ServiceAuthenticationForm';

export const KonzultaCredentialsAuth = (): ReactElement => {
  const {data: konzultaConfigData} = useSmsGetKonzultaCredentialsQuery();
  const [patchKonzultaConfig] = useSmsPatchKonzultaCredentialsMutation();

  const updateCredentials = (formData: KonzultaCredentials) => {
    patchKonzultaConfig({
      body: {
        password: formData.password,
        username: formData.username,
      },
    })
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.changesSuccessfullySaved'));
      })
      .catch(handleApiError);
  };

  return (
    <Card title={i18n.t('general.labels.accessDataAuth')}>
      <ServiceAuthenticationForm
        initialValues={{
          username: konzultaConfigData?.username,
        }}
        onSubmit={updateCredentials}
      />
    </Card>
  );
};
